/* Derived from the official LOOP MAXI 600 ml color list and Color-Chart-LOOP-2026.pdf. */
window.NEKAS_LOOP_MAXI_600ML_COLORS = Object.freeze([
  {
    "name": "MAXI WHITE",
    "code": "LP-415",
    "hex": "#FFFFFF",
    "column": 1,
    "position": 1
  },
  {
    "name": "MAXI BLACK",
    "code": "LP-416",
    "hex": "#040606",
    "column": 1,
    "position": 2
  },
  {
    "name": "BLACK ASPHALT",
    "code": "LP-435",
    "hex": "#231F20",
    "column": 1,
    "position": 3
  },
  {
    "name": "MAXI VALENCIA",
    "code": "LP-417",
    "hex": "#FCD405",
    "column": 1,
    "position": 4
  },
  {
    "name": "MAXI ROSENDHAL",
    "code": "LP-418",
    "hex": "#F47216",
    "column": 1,
    "position": 5
  },
  {
    "name": "MAXI LIVERPOOL",
    "code": "LP-419",
    "hex": "#CF232B",
    "column": 2,
    "position": 1
  },
  {
    "name": "MAXI DUNDALK",
    "code": "LP-420",
    "hex": "#F68DB9",
    "column": 2,
    "position": 2
  },
  {
    "name": "MAXI PORTO",
    "code": "LP-421",
    "hex": "#B9097A",
    "column": 2,
    "position": 3
  },
  {
    "name": "MAXI MORA",
    "code": "LP-422",
    "hex": "#483B9D",
    "column": 2,
    "position": 4
  },
  {
    "name": "MAXI LENS",
    "code": "LP-423",
    "hex": "#1C8CD5",
    "column": 2,
    "position": 5
  },
  {
    "name": "MAXI LUCCA",
    "code": "LP-424",
    "hex": "#519A54",
    "column": 3,
    "position": 1
  },
  {
    "name": "MAXI BREST",
    "code": "LP-425",
    "hex": "#06294A",
    "column": 3,
    "position": 2
  },
  {
    "name": "MAXI LEEDS",
    "code": "LP-426",
    "hex": "#920D1B",
    "column": 3,
    "position": 3
  },
  {
    "name": "MAXI PERUGIA",
    "code": "LP-427",
    "hex": "#173C0E",
    "column": 3,
    "position": 4
  },
  {
    "name": "MAXI MALMO",
    "code": "LP-428",
    "hex": "#917AC4",
    "column": 3,
    "position": 5
  },
  {
    "name": "MAXI BERGAMO",
    "code": "LP-429",
    "hex": "#0AABBA",
    "column": 4,
    "position": 1
  },
  {
    "name": "MAXI MADRID",
    "code": "LP-433",
    "hex": "#FFF870",
    "column": 4,
    "position": 2
  },
  {
    "name": "MAXI SAN FRANCISCO",
    "code": "LP-434",
    "hex": "#707A84",
    "column": 4,
    "position": 3
  },
  {
    "name": "CHROME - HEAVY METAL",
    "code": "LP-436",
    "hex": "#BEC2C5",
    "column": 4,
    "position": 4
  },
  {
    "name": "GOLD - HEAVY METAL",
    "code": "LP-440",
    "hex": "#D5A940",
    "column": 4,
    "position": 5
  },
  {
    "name": "MAXI TILBURG",
    "code": "LP-442",
    "hex": "#F2541B",
    "column": 5,
    "position": 1
  },
  {
    "name": "MAXI MOSS",
    "code": "LP-443",
    "hex": "#5F3B9F",
    "column": 5,
    "position": 2
  },
  {
    "name": "MAXI VENEZIA",
    "code": "LP-444",
    "hex": "#0C566C",
    "column": 5,
    "position": 3
  },
  {
    "name": "FIRENZE",
    "code": "LP-445",
    "hex": "#1B7529",
    "column": 5,
    "position": 4
  },
  {
    "name": "MAXI SACRAMENTO",
    "code": "LP-446",
    "hex": "#34313B",
    "column": 5,
    "position": 5
  }
]);
